export default __webpack_public_path__ + "static/media/partner-2.e2f37255.png";